import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import TokenRedirectService from '../../common/services/token-redirect.service';
import { ChangePaymentInfoAction } from './change-payment-info.action';

/* @ngInject */
export default class ChangePaymentInfoController implements ActionHandler {
  private dialogElement;
  protected onChangePaymentMethodApprove: () => any;

  constructor(
    protected $element,
    protected actionDispatcher: ActionDispatcherService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#change-payment-info').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof ChangePaymentInfoAction) {
      this.onChangePaymentMethodApprove = action.onChangePaymentMethodApprove;
      this.openDialog();
    }
  }

  protected onApprove() {
    this.onChangePaymentMethodApprove();
    this.close();
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  public close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/change-payment-info-dialog/change-payment-info.controller.ts